module.exports = __webpack_public_path__ + "static/media/Moon.cf338b5c.png";